import { useEffect } from "react";

/**
 * Paints the cream auth background on the DOCUMENT CANVAS, not just on the
 * screen's own wrapper div.
 *
 * Why this exists. The onboarding / signup / sign-in / verification / reset screens all draw
 * their cream on an inner `min-h-screen` div. Inside the iOS app that div fills
 * the web view exactly - and the strips the web view does NOT occupy (behind the
 * status bar at the top, behind the home indicator at the bottom) are painted
 * from the document canvas, whose colour is propagated from `body`. `body` is
 * white app-wide, so those two strips came out white and the cream looked like a
 * card sitting inside a white frame. That is the "white header and footer on
 * each page" the client reported.
 *
 * A background on any inner element can never reach outside the layout viewport,
 * so the only fix is to colour the canvas itself - which is what the
 * `auth-screen-bg` class in index.css does. Scoped to these screens and removed
 * on unmount, so every other screen in the app keeps the white body it has now.
 */
export const AUTH_SCREEN_BG = "#F2F0EC";

const BODY_CLASS = "auth-screen-bg";

export default function useAuthScreenBackground() {
  useEffect(() => {
    document.body.classList.add(BODY_CLASS);
    return () => document.body.classList.remove(BODY_CLASS);
  }, []);
}
